import React from 'react';
import Icon from '../../../components/AppIcon';

const CohortRetentionTable = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6">
        <div className="text-center text-muted-foreground text-sm py-8">
          No cohort retention data available
        </div>
      </div>
    );
  }

  const getRetentionColor = (rate) => {
    if (rate >= 80) return 'bg-success/20 text-success';
    if (rate >= 60) return 'bg-primary/20 text-primary';
    if (rate >= 40) return 'bg-warning/20 text-warning';
    return 'bg-error/20 text-error';
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Calendar" size={20} className="text-primary" strokeWidth={2} />
        <h2 className="text-lg font-heading font-semibold text-foreground">
          Cohort Retention Analysis
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">
                Cohort
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Users
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Day 1
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Day 7
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Day 14
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Day 30
              </th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">
                Premium %
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((cohort, index) => (
              <tr key={cohort?.cohort} className="border-b border-border hover:bg-muted/5 transition-smooth">
                <td className="py-3 px-4 text-sm font-medium text-foreground">
                  {cohort?.cohort}
                </td>
                <td className="py-3 px-4 text-sm text-center text-foreground">
                  {cohort?.totalUsers?.toLocaleString()}
                </td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${getRetentionColor(cohort?.day1)}`}>
                    {cohort?.day1}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${getRetentionColor(cohort?.day7)}`}>
                    {cohort?.day7}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${getRetentionColor(cohort?.day14)}`}>
                    {cohort?.day14}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${getRetentionColor(cohort?.day30)}`}>
                    {cohort?.day30}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-primary/20 text-primary">
                    {cohort?.premiumConversion}%
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-start gap-2 text-xs text-muted-foreground">
          <Icon name="Info" size={14} strokeWidth={2} className="mt-0.5" />
          <p>
            Cohort retention shows the percentage of users who remain active after signup. 
            Premium % indicates the conversion rate to Premium plans for each cohort.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CohortRetentionTable;